import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";
import * as Sentry from "@sentry/react";
import { initSentry } from "@/lib/sentry";
import { AppErrorFallback } from "@/components/AppErrorFallback";
import App from "./App.tsx";

// Self-hosted fonts (only the weights actually used — see tailwind.config.ts
// fontFamily + grep of font-* utility classes). Same origin as the app, so
// no cross-origin round trip and the PWA service worker can precache them.
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "@fontsource/plus-jakarta-sans/600.css";
import "@fontsource/plus-jakarta-sans/700.css";
import "@fontsource/plus-jakarta-sans/800.css";
import "@fontsource/ibm-plex-mono/400.css";
import "@fontsource/ibm-plex-mono/500.css";

import "./index.css";

initSentry();

createRoot(document.getElementById("root")!).render(
  <Sentry.ErrorBoundary fallback={({ error }) => <AppErrorFallback error={error as Error} />}>
    <HelmetProvider>
      <Analytics />
      <SpeedInsights />
      <App />
    </HelmetProvider>
  </Sentry.ErrorBoundary>
);
